var _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgBtnSplitCard = function SvgBtnSplitCard(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, /*#__PURE__*/React.createElement("mask", {
    id: "btn-split-card_svg__mask0_259_6352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#btn-split-card_svg__mask0_259_6352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.4375C14.6391 2.4375 15.5625 3.36091 15.5625 4.5V13.5C15.5625 14.6391 14.6391 15.5625 13.5 15.5625H4.5C3.36091 15.5625 2.4375 14.6391 2.4375 13.5V4.5C2.4375 3.36091 3.36091 2.4375 4.5 2.4375H13.5ZM4.5 3.5625C3.98223 3.5625 3.5625 3.98223 3.5625 4.5V13.5C3.5625 14.0178 3.98223 14.4375 4.5 14.4375H13.5C14.0178 14.4375 14.4375 14.0178 14.4375 13.5V4.5C14.4375 3.98223 14.0178 3.5625 13.5 3.5625H4.5ZM7.94727 9.16309C8.16684 8.94369 8.52255 8.94379 8.74219 9.16309C8.96186 9.38276 8.96186 9.73931 8.74219 9.95898L6.77734 11.9248H7.3125C7.62316 11.9248 7.875 12.1766 7.875 12.4873C7.875 12.798 7.62316 13.0498 7.3125 13.0498H5.4375C5.16566 13.0498 4.93916 12.8569 4.88672 12.6006L4.875 12.4873V10.6123C4.875 10.3016 5.12684 10.0498 5.4375 10.0498C5.74816 10.0498 6 10.3016 6 10.6123V11.1104L7.94727 9.16309ZM12.9756 4.51172C13.2318 4.56425 13.4248 4.79075 13.4248 5.0625V6.9375C13.4248 7.24808 13.1729 7.49987 12.8623 7.5C12.5516 7.5 12.2998 7.24816 12.2998 6.9375V6.40039L10.334 8.36719C10.1143 8.58686 9.75776 8.58686 9.53809 8.36719C9.31855 8.14757 9.31861 7.79192 9.53809 7.57227L11.4854 5.625H10.9873C10.6766 5.625 10.4248 5.37316 10.4248 5.0625C10.4248 4.75184 10.6766 4.5 10.9873 4.5H12.8623C12.9011 4.50002 12.939 4.50421 12.9756 4.51172Z",
    fill: "#39404D"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
export default SvgBtnSplitCard;